// This file is generated by the command "yarn workspace @classify/illustrations build"
export default 'https://static.oc-static.com/illustrations/FAQ-1.png';
